import { __extends } from "tslib";
import * as React from 'react';
export var TOrigin;
(function (TOrigin) {
    TOrigin["Dashboard"] = "dashboard";
    TOrigin["mySites"] = "my sites";
    TOrigin["trash"] = "trash";
    TOrigin["siteList"] = "site_list.quick-actions";
    TOrigin["SiteSettings"] = "site_settings.quick-actions";
    TOrigin["SiteSettingsOverview"] = "site_settings.overview-tab";
    TOrigin["SiteSettingsDomain"] = "site_settings.domain-tab";
})(TOrigin || (TOrigin = {}));
var DialogComponent = /** @class */ (function (_super) {
    __extends(DialogComponent, _super);
    function DialogComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.initApi();
        return _this;
    }
    return DialogComponent;
}(React.PureComponent));
export { DialogComponent };
//# sourceMappingURL=index.js.map